/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { questionDataRequestAttributeSchema } from './QuestionDataRequestAttributeSchema'
import { questionDataRequestSubtypeSchema } from './QuestionDataRequestSubtypeSchema'
import { questionDataRequestTypeSchema } from './QuestionDataRequestTypeSchema'

export const questionDataRequestSchema = z.object({
	id: z.string().uuid().nullable().optional(),
	label: z.string(),
	type: questionDataRequestTypeSchema,
	attribute: questionDataRequestAttributeSchema.nullable().optional(),
	subtype: questionDataRequestSubtypeSchema.nullable().optional(),
	validationRules: z.array(z.string()).nullable().optional(),
	position: z.number(),
	options: z.array(
		z.object({
			id: z.string().nullable(),
			label: z.string(),
			position: z.number(),
			isDisqualifying: z.boolean().nullable().default(false),
			scoreValue: z.number().nullable(),
			consentType: z.string().nullable(),
		}),
	).nullable().optional(),
	scores: z.array(z.object({ questionId: z.string().uuid(), optionId: z.string(), scoreValue: z.number() }))
		.nullable().optional(),
	weight: z.number().nullable().optional(),
})

export type QuestionDataRequestSchema = z.infer<typeof questionDataRequestSchema>
